<template>
  <div class="banner-header">
    <div class="banner-left">
      <div class="left-tab blue" @click="gotocfbb()">{{ name }}</div>
      <div class="left-tab green" @click="toPart('knowledge-base')">
        论文知库
      </div>
      <div class="left-tab yellow" @click="toPart('members-home')">
        会员之家
      </div>
      <div class="left-tab pink" @click="toPart('expert-base')">专家智库</div>
    </div>
    <div class="banner-right">
      <banner></banner>
    </div>
  </div>
</template>

<script>
const HEIGHT =
  document.body.clientHeight || document.documentElement.clientHeight
const WIDTH = document.body.clientWidth || document.documentElement.clientWidth
import Banner from './Banner.vue'
export default {
  props: {},
  data() {
    return {
      name: ''
    }
  },
  computed: {},
  created() {
    this.getCfbbSide()
  },
  mounted() {},
  watch: {},
  methods: {
    getCfbbSide() {
      this.httpGet(this.$root.cfbbDetail, {})
        .then((result) => {
          this.name = result.name
        })
        .catch((error) => {
          console.error('cfbbDetail', error)
        })
    },
    toPart(name) {
      this.$router.push({
        name: name
      })
    },
    gotocfbb() {
      this.$router.push({
        name: 'cfbb'
      })
    }
  },
  components: {
    Banner
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-header {
  width: 100%;
  // margin-top: 20px;
  height: 380px;
  flex-x(space-between);

  .banner-left {
    width: 23.7288%;
    height: 100%;

    .left-tab {
      width: 100%;
      height: 22.5%;
      border-radius: 8px;
      box-shadow: 0px 2px 8px 0px rgba(23, 23, 26, 0.2);
      margin: 8px 0;
      flex-center();
      color: white;

      &.blue {
        cursor: pointer;
        width: 100%;
        height: 22.5%;
        background-image: url('~@/assets/img/side-blue.png');
        background-size: 100% 100%;
      }

      &.green {
        cursor: pointer;
        width: 100%;
        height: 22.5%;
        background-image: url('~@/assets/img/side-green.png');
        background-size: 100% 100%;
      }

      &.yellow {
        cursor: pointer;
        width: 100%;
        height: 22.5%;
        background-image: url('~@/assets/img/side-yellow.png');
        background-size: 100% 100%;
      }

      &.pink {
        cursor: pointer;
        width: 100%;
        height: 22.5%;
        background-image: url('~@/assets/img/side-pink.png');
        background-size: 100% 100%;
      }
    }
  }

  .banner-right {
    width: 74.5762%;
    height: 100%;
  }
}
</style>
